import Typography from '@cobliteam/ui/components/Typography';

interface BlankslateInfoProps {
  title: string;
  description?: string;
}

const BlankslateInfo = ({ title, description }: BlankslateInfoProps) => {
  return (
    <div className='space-y-2'>
      <Typography as='h3' variant='text-md-semibold' color='secondary' className='text-center'>
        {title}
      </Typography>
      {description && (
        <Typography as='p' color='secondary' variant='text-md' className='text-center'>
          {description}
        </Typography>
      )}
    </div>
  );
};

export default BlankslateInfo;
